import { render } from "./CyanPageWrapper.vue?vue&type=template&id=bd116910&scoped=true"
import script from "./CyanPageWrapper.vue?vue&type=script&lang=ts"
export * from "./CyanPageWrapper.vue?vue&type=script&lang=ts"

import "./CyanPageWrapper.vue?vue&type=style&index=0&id=bd116910&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd116910"

export default script